export default __webpack_public_path__ + "static/media/valores.32d3fc19.svg";